import { render, staticRenderFns } from "./PlanNotesTable.vue?vue&type=template&id=562a27ac&scoped=true&lang=pug"
import script from "./PlanNotesTable.vue?vue&type=script&lang=js"
export * from "./PlanNotesTable.vue?vue&type=script&lang=js"
import style0 from "./PlanNotesTable.vue?vue&type=style&index=0&id=562a27ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "562a27ac",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Icon: require('/home/docker/code/frontend/components/Icon.vue').default,Spinner: require('/home/docker/code/frontend/components/Spinner.vue').default})
